import { FiHome, FiDollarSign, FiUser } from "react-icons/fi";
import {
  MdProductionQuantityLimits,
  MdOutlinePeopleAlt,
  MdOutlineCountertops,
} from "react-icons/md";
import { AiOutlineTool, AiOutlineAppstore } from "react-icons/ai";
import {
  FaWarehouse,
  FaClipboardList,
  FaUsers,
  FaBoxes,
  FaRegMoneyBillAlt,
} from "react-icons/fa";
import {
  BsArchiveFill,
  BsCreditCard,
  BsCurrencyExchange,
} from "react-icons/bs";
import { GrMoney, GrPowerCycle, GrUserWorker } from "react-icons/gr";
import { RiFileList2Fill, RiMoneyDollarCircleLine } from "react-icons/ri";
import { FaChartPie } from "react-icons/fa";
import { IoDocumentTextOutline } from "react-icons/io5";
import { PiListChecksBold } from "react-icons/pi";
import { FaTasks } from "react-icons/fa";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
import { IoSettings } from "react-icons/io5";
import { FaInfoCircle } from "react-icons/fa";
import { IoPrintOutline } from "react-icons/io5";
import { IoSettingsSharp } from "react-icons/io5";
import { FaCodeFork, FaMoneyBillTrendUp } from "react-icons/fa6";
import { FaReceipt } from "react-icons/fa";

interface MenuItem {
  key: string;
  icon?: React.ReactElement;
  label: string;
  roles: string[];
  children?: MenuItem[];
}

export const items: MenuItem[] = [
  {
    key: "/",
    icon: <FiHome />,
    label: "Главная",
    roles: [
      "admin",
      "director",
      "cashier",
      "salesDept",
      "manager",
      "accountant",
      "foreman",
      "inventoryMgr",
    ],
  },
  {
    key: "/produces",
    label: "Продукции",
    icon: <MdProductionQuantityLimits />,
    roles: ["foreman"],
  },
  {
    key: "/machines",
    label: "Станки",
    icon: <AiOutlineTool />,
    roles: ["accountant"],
  },
  {
    key: "/production",
    icon: <AiOutlineAppstore />,
    label: "Производство",
    roles: ["admin", "director", "manager", "cashier"],
    children: [
      {
        key: "/machines",
        label: "Станки",
        icon: <AiOutlineTool />,
        roles: ["admin", "director", "manager", "cashier"],
      },
      {
        key: "/materials",
        label: "Материалы",
        icon: <FaWarehouse />,
        roles: ["admin", "director", "manager", "cashier"],
      },
      {
        key: "/produces",
        label: "Продукции",
        icon: <MdProductionQuantityLimits />,
        roles: ["admin", "director", "manager", "cashier"],
      },
    ],
  },
  {
    key: "/price",
    icon: <RiMoneyDollarCircleLine />,
    label: "Прайсы",
    roles: ["admin", "director"],
    children: [
      {
        key: "/price/materials",
        label: "Материалы",
        icon: <FaWarehouse />,
        roles: ["admin", "director"],
      },
      {
        key: "/price/produces",
        label: "Продукции",
        icon: <MdProductionQuantityLimits />,
        roles: ["admin", "director"],
      },
    ],
  },
  {
    key: "/clients",
    icon: <MdOutlinePeopleAlt />,
    label: "Клиенты",
    roles: ["admin", "director", "cashier", "manager"],
    children: [
      {
        key: "/clients/purchase",
        label: "Покупка",
        icon: <FaBoxes />,
        roles: ["admin", "director", "cashier", "manager"],
      },
      {
        key: "/clients/sale",
        label: "Продажа",
        icon: <FaBoxes />,
        roles: ["admin", "director", "cashier", "manager"],
      },
      {
        key: "/clients/cash-transfers",
        label: "Обнал",
        icon: <BsCurrencyExchange />,
        roles: ["admin", "director", "cashier"],
      },
    ],
  },
  // salesDept
  {
    key: "/clients",
    icon: <MdOutlinePeopleAlt />,
    label: "Клиенты",
    roles: ["salesDept"],
    children: [
      {
        key: "/clients/purchase",
        label: "Покупка",
        icon: <FaBoxes />,
        roles: ["salesDept"],
      },
      {
        key: "/clients/sale",
        label: "Продажа",
        icon: <FaBoxes />,
        roles: ["salesDept"],
      },
    ],
  },
  {
    key: "/reports",
    icon: <IoDocumentTextOutline />,
    label: "Отчеты",
    roles: ["admin", "director", "cashier", "manager"],
    children: [
      {
        key: "/all/Покупка/Покупка/orders",
        label: "Покупка",
        icon: <FaBoxes />,
        roles: ["admin", "director", "cashier", "manager"],
      },
      {
        key: "/all/Продажа/Продажа/orders",
        label: "Продажа",
        icon: <FaBoxes />,
        roles: ["admin", "director", "cashier", "manager"],
      },
      {
        key: "/all/Производства/all/reports",
        label: "Производства",
        icon: <FaBoxes />,
        roles: ["admin", "director", "cashier", "manager"],
      },
      {
        key: "/all/Зарплата/salary/salary-reports",
        label: "Зарплата",
        icon: <FaRegMoneyBillAlt />,
        roles: ["admin", "director", "cashier", "manager"],
      },

      {
        key: "audit-actions",
        label: "Ревизия",
        icon: <PiListChecksBold />,
        roles: ["admin", "director"],
      },
      {
        key: "/delivery-expenses",
        icon: <FaMoneyBillTrendUp />,
        label: "Доп.расходы",
        roles: ["admin", "director", "cashier"],
      },
      {
        key: "/forks",
        icon: <FaCodeFork />,
        label: "Откаты",
        roles: ["admin", "director", "cashier"],
      },
      {
        key: "/transactions/all/cashbox/",
        icon: <GrMoney />,
        label: "Отчеты касса",
        roles: ["admin", "director", "cashier", "manager"],
      },
    ],
  },
  {
    key: "/vat",
    icon: <FaReceipt />,
    label: "НДС",
    roles: ["admin", "director", "accountant"],
    children: [
      {
        key: "/vat/clients",
        label: "Клиенты НДС",
        icon: <MdOutlinePeopleAlt />,
        roles: ["admin", "director", "accountant"],
      },
      {
        key: "/vat/transactions",
        label: "Транзакции НДС",
        icon: <FaReceipt />,
        roles: ["admin", "director", "accountant"],
      },
      {
        key: "/vat/reports",
        label: "Отчеты НДС",
        icon: <IoDocumentTextOutline />,
        roles: ["admin", "director", "accountant"],
      },
    ],
  },
  {
    key: "/task-orders",
    icon: <FaTasks />,
    label: "Задачи-Заказы",
    roles: ["admin", "director", "salesDept", "manager", "foreman", "cashier"],
  },
  {
    key: "/tasks",
    icon: <FaTasks />,
    label: "Задачи",
    roles: ["admin", "director", "cashier", "salesDept", "manager", "accountant", "foreman", "inventoryMgr"],
  },
  {
    key: "/cashboxes",
    icon: <BsCreditCard />,
    label: "Кассы",
    roles: ["admin", "director", "cashier", "manager"],
  },
  {
    key: "cash-transfers/all/Все",
    label: "Конвертация",
    icon: <BsCurrencyExchange />,
    roles: ["admin", "director", "cashier", "manager"],
  },
  {
    key: "/all/Зарплата/salary/salary-reports",
    label: "Отчеты зарплаты",
    icon: <FaRegMoneyBillAlt />,
    roles: ["accountant"],
  },
  {
    key: "/profit-credits-expenses",
    icon: <FaChartPie />,
    label: "Прибыли и убытки",
    roles: ["admin", "director"],
  },
  {
    key: "/audit",
    icon: <PiListChecksBold />,
    label: "Ревизия",
    roles: ["admin", "director"],
  },
  {
    key: "/action-log",
    icon: <PiListChecksBold />,
    label: "Журнал действий",
    roles: ["admin", "director"],
  },

  {
    key: "/inventory",
    icon: <FaBoxes />,
    label: "Инвентарь",
    roles: ["admin", "director", "cashier", "manager", "inventoryMgr"],
  },
  {
    key: "/partners",
    icon: <FaMoneyBillTrendUp />,
    label: "Партнёры",
    roles: ["admin", "director", "cashier"],
  },
  {
    key: "/staff",
    icon: <FaUsers />,
    label: "Персонал",
    roles: ["admin"],
  },
  {
    key: "/crm",
    icon: <FiDollarSign />,
    label: "Продажи",
    roles: ["admin"],
    children: [
      {
        key: "/crm/sales-users",
        label: "Продажники",
        icon: <FaUsers />,
        roles: ["admin"],
      },
      {
        key: "/commission-request",
        label: "Запросы на комиссию",
        icon: <FaRegMoneyBillAlt />,
        roles: ["admin"],
      },
    ],
  },
  {
    key: "/workers",
    icon: <FaClipboardList />,
    label: "Сотрудники",
    roles: ["admin", "director", "manager", "accountant", "cashier"],
  },
  {
    key: "/salary",
    icon: <FaRegMoneyBillAlt />,
    label: "Зарплата",
    roles: ["admin", "director", "cashier", "manager", "accountant"],
  },
  {
    key: "/salary-request",
    icon: <FaRegMoneyBillAlt />,
    label: "Запросы на увеличение зарплаты",
    roles: ["admin", "accountant", "manager"],
  },
  {
    key: "/lists",
    icon: <HiOutlineClipboardDocumentList />,
    label: "Констр.Документация",
    roles: ["admin", "director", "foreman", "accountant"],
  },
  {
    key: "/meter-readings",
    icon: <MdOutlineCountertops />,
    label: "Счетчикы",
    roles: ["admin", "director", "cashier"],
  },
  {
    key: "/fillers",
    icon: <HiOutlineClipboardDocumentList />,
    label: "Филлеры",
    roles: ["admin", "director", "foreman", "cashier"],
  },

  {
    key: "/files",
    icon: <RiFileList2Fill />,
    label: "Файлы",
    roles: ["admin", "director", "salesDept", "manager", "foreman", "cashier"],
  },
  {
    key: "/positions",
    icon: <GrUserWorker />,
    label: "Должности",
    roles: ["admin", "director", "cashier"]
  },
  {
    key: "/settings",
    icon: <IoSettings />,
    label: "Настройки",
    roles: ["admin"],
    children: [
      {
        key: "/settings/global",
        label: "Общие",
        icon: <IoSettingsSharp />,
        roles: ["admin"],
      },
      {
        key: "/settings/company",
        label: "Данные компании",
        icon: <FaInfoCircle />,
        roles: ["admin"],
      },
      {
        key: "/settings/order",
        label: "Печать заказа",
        icon: <IoPrintOutline />,
        roles: ["admin"],
      },
      {
        key: "/settings/report",
        label: "Печать отчёта",
        icon: <IoPrintOutline />,
        roles: ["admin"],
      },
      {
        key: "/settings/turnover",
        label: "Оборот (курс)",
        icon: <BsCurrencyExchange />,
        roles: ["admin"],
      },
      {
        key: "/expenses",
        icon: <FiDollarSign />,
        label: "Расходы",
        roles: ["admin", "manager"],
      },
      {
        key: "/cost-analysis",
        icon: <FaChartPie />,
        label: "Анализ себестоимости",
        roles: ["admin", "director", "accountant", "cashier"],
      },
    ],
  },
  {
    key: "/archive",
    icon: <BsArchiveFill />,
    label: "Архивы",
    roles: ["admin"],
    children: [
      {
        key: "/archive/orders",
        label: "Заказы",
        roles: ["admin"],
      },
      {
        key: "/archive/transactions",
        label: "Транзакции",
        roles: ["admin"],
      },
      {
        key: "/archive/salary-reports",
        label: "Отчёты (Зарплата)",
        roles: ["admin"],
      },
      {
        key: "/archive/reports",
        label: "Отчёты (Производство)",
        roles: ["admin"],
      },
      {
        key: "/archive/cash-transfer-clients",
        label: "Клиенты (Обнал)",
        roles: ["admin"],
      },
      {
        key: "/archive/clients",
        label: "Клиенты",
        roles: ["admin"],
      },
      {
        key: "/archive/cash-transfers",
        label: "Конвертации",
        roles: ["admin"],
      },
      {
        key: "/archive/task-order",
        label: "Задача заказ",
        roles: ["admin"],
      },
      {
        key: "/archive/inventory",
        label: "Инвентарь",
        roles: ["admin"],
      },
      {
        key: "/archive/inventory-logs",
        label: "Журнал инвентарль",
        roles: ["admin"],
      },
      {
        key: "/archive/workers",
        label: "Сотрудники",
        roles: ["admin"],
      },
      {
        key: "/archive/users",
        label: "Пользователи",
        roles: ["admin"],
      },
    ],
  },

  {
    key: "/profile",
    icon: <FiUser />,
    label: "Профиль",
    roles: [
      "admin",
      "director",
      "cashier",
      "worker",
      "salesDept",
      "manager",
      "accountant",
      "foreman",
      "inventoryMgr",
    ],
  },
];
